<div class="ptf-cart" uppDataid="ptf-cart">
    <div
        #swipeHost
        class="ptf-cart__swipe-host"
        [hidden]="ShowProduct"
        uppDataid="ptf-cart-swipe-host"
    >
        <div
            class="ptf-cart__layer"
            [hidden]="!ShowCatalog"
            uppDataid="ptf-cart-catalog-layer"
        >
            <upp-cart-select
                [place]="place"
                [ticket]="ticket"
                [locked]="IsLocked"
                (ToPanel)="OnChildPanel($event)"
            ></upp-cart-select>
        </div>

        <div
            class="ptf-cart__layer"
            [hidden]="!ShowTicket"
            uppDataid="ptf-cart-ticket-layer"
        >
            <upp-ticket-edit
                *ngIf="TicketLoaded"
                [place]="place"
                [ticket]="ticket"
                [mode]="TicketMode"
                [action]="TicketAction"
                (OnLock)="IsLocked = $event"
                (ToPanel)="OnChildPanel($event)"
            ></upp-ticket-edit>
        </div>
    </div>

    <div
        class="ptf-cart__layer"
        *ngIf="ShowProduct"
        uppDataid="ptf-cart-product-layer"
    >
        <upp-product-cart
            [place]="place"
            [ticket]="ticket"
            [product]="PanelProduct"
            [options]="PanelOptions"
            [ticketproduct]="PanelTicketProduct"
            (ToPanel)="OnChildPanel($event)"
        ></upp-product-cart>
    </div>
</div>
